/**
 * What a submitted widget collapses to (spec-widget-mcp 05 AC-11, canvas `Sent: …`): one readable
 * line of what was sent, built from the payload's own labels. A one-time code is masked.
 */
import { NO_SLOT } from "../kinds";
import { allFields } from "../useWidgetForm";
import { formatAddress } from "./address";
import { dayLabel, slotLabel } from "./slots";

const labelOf = (options, value) => (Array.isArray(options) ? options.find((o) => o.value === value)?.label : null) ?? String(value);
const list = (options, value) => (Array.isArray(value) ? value : [value]).map((v) => labelOf(options, v)).join(", ");

function fieldText(field, value) {
	if (field.type === "address") return formatAddress(value);
	if (field.type === "otp") return "•".repeat(String(value).length);
	if (field.type === "choice" || field.type === "select") return list(field.options, value);
	return Array.isArray(value) ? value.join(", ") : String(value);
}

/**
 * @param {object} envelope the widget envelope (kind + payload)
 * @param {object|null} values the submitted values (`submittedValues`, or what this client sent)
 * @param {{ confirmed?: string, declined?: string, none?: string, lang?: string }} [copy]
 * @returns {string} empty when nothing is known about what was sent
 */
export function describeSubmission(envelope, values, copy = {}) {
	if (!values || typeof values !== "object") return "";
	const p = envelope?.payload || {};
	switch (envelope?.kind) {
	case "question":
		return values.choice === undefined ? "" : list(p.options, values.choice);
	case "confirmation":
		return values.confirmed === true ? (copy.confirmed || "Confirmed") : (copy.declined || "Declined");
	case "slot_picker": {
		if (values.slotId === NO_SLOT) return p.noneLabel || copy.none || "None of these work";
		const slot = (p.slots || []).find((s) => s.id === values.slotId);
		return slot ? `${dayLabel(slot.start, p.timezone, copy.lang)}, ${slotLabel(slot, p.timezone)}` : "";
	}
	case "data_collection":
		return allFields(p)
			.filter((f) => values[f.name] !== undefined)
			.map((f) => `${f.label}: ${fieldText(f, values[f.name])}`)
			.join("; ");
	default:
		return "";
	}
}
